import type { FaireBrandEntity } from "../../entity_types/brand";

export const astoriaGranolaCo: FaireBrandEntity = {
  token: "astoria-granola-co",
  type: "brand",
  name: "Astoria Granola Co.",
  logoUrl:
    "https://cdn.prerelease.faire.dev/fastly/1f5fc70299bc5e6af6328c56ce5a6715af841aaa37d9002be999bf81d53d7624.webp",
  description: "Small-batch artisan granola and breakfast items",
  rating: 4.8,
  location: "Astoria, NY",
  minimumOrderDollars: 75,
  tags: ["breakfast", "artisan", "healthy"],
  categoryTokens: ["cat_food-snacks"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "entity-db-bootstrap",
  },
};
